var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    staticClass: "ma-auto card",
    attrs: {
      "flat": "",
      "align": "center"
    }
  }, [_c('v-card-title', {
    staticClass: "mb-8 align-center justify-center"
  }, [_vm.imgSrc ? _c('v-img', {
    attrs: {
      "max-width": "190px",
      "contain": "",
      "src": _vm.imgSrc
    }
  }) : _c('v-img', {
    attrs: {
      "max-width": "190px",
      "contain": "",
      "src": require("@/assets/partner_not_found.svg")
    }
  })], 1), _c('v-card-text', [_c('p', [_vm._v(_vm._s(_vm.$t("components.utility.ErrorCard.title")))]), _c('p', [_vm._v(_vm._s(_vm.$t("components.utility.ErrorCard.subtitle")))]), _c('v-breadcrumbs', {
    staticClass: "ma-4 align-center justify-center",
    attrs: {
      "items": _vm.items
    }
  })], 1), _c('v-card-actions', {
    staticClass: "align-center justify-center"
  }, [_vm.showLoginBtn ? _c('v-btn', {
    attrs: {
      "loading": _vm.isLoadingLogin,
      "text": ""
    },
    on: {
      "click": _vm.logout
    }
  }, [_vm._v(_vm._s(_vm.$t("components.utility.ErrorCard.login")) + " ")]) : _vm._e(), _c('v-btn', {
    attrs: {
      "loading": _vm.loading,
      "color": "primary",
      "elevation": "0"
    },
    on: {
      "click": _vm.reload
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("components.utility.ErrorCard.btnText")) + " ")])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }